/* unplugin-vue-components disabled */import script from "./CardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHeader.vue?vue&type=script&setup=true&lang=js"

import "./CardHeader.vue?vue&type=style&index=0&id=342c29b5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342c29b5"]])

export default __exports__